import { sendSmsApi } from "../../../api/api";

const actions = {
    async smsUidAction(context, params) {
        try {
            const result = await sendSmsApi(params);
            return new Promise((resolve, reject) => {
                if (result.status === 200) {
                    context.commit('smsUidMutation', result.data.smsUid);
                    resolve(result.status);
                }
                else reject(result.status);
            });
        } catch (error) {
            return new Promise((resolve, reject) => {
                reject(error.response.data.code)
            });
        }
    },
};

export default actions;
